"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Renderer = void 0;
require("canvas-5-polyfill");
const fym_lib_1 = require("@faceyourmanga/fym-lib");
const canvas_1 = require("canvas");
const ClientSVGSetting_1 = require("../svg/ClientSVGSetting");
const SVG_1 = require("../svg/SVG");
const LOG = false;
let watermark;
SVG_1.SVG.toImage(ClientSVGSetting_1.ClientSVGSetting.watermark).then(loaded => (watermark = loaded));
const bNode = canvas_1.Canvas !== undefined;
/**
 * Classe che si occupa di ricevere un array di risorse renderizzabili e restituisce il bitmap
 */
class Renderer {
    static async render(renderRequest, settings) {
        const width = settings.width / settings.scale;
        const height = settings.height / settings.scale;
        const canvas = canvas_1.createCanvas(width, height);
        const context = canvas.getContext('2d', {
            alpha: false,
            pixelFormat: bNode ? 'RGBA32' : undefined,
        });
        context.patternQuality = 'best';
        context.quality = 'best';
        context.imageSmoothingEnabled = true;
        context.imageSmoothingQuality = 'high';
        context.antialias = 'subpixel';
        context.clearRect(0, 0, width, height);
        for (let i = 0, len = renderRequest.length; i < len; i++) {
            const renderItem = renderRequest[i];
            context.save();
            context.beginPath();
            const renderItemImage = await SVG_1.SVG.toImage(renderItem.svg);
            renderItemImage.width = width;
            renderItemImage.height = height;
            const imageBounding = Renderer.calculateRelativeBounding(renderItem.bounding, width, height);
            // Check image can be masked
            const masks = renderItem.masks;
            if (typeof masks === 'undefined' || masks === null || masks.length <= 0) {
                Renderer.drawImage(context, renderItemImage, imageBounding, renderItem.transform, settings);
            }
            else {
                masks.forEach(mask => {
                    const p = new Path2D();
                    const p1 = new Path2D(mask.path);
                    //////
                    // Calculate current mask bounding
                    const maskBounding = mask.bounding;
                    const [maskBoundingX1, maskBoundingY1, maskBoundingX2, maskBoundingY2] = Renderer.calculateRelativeBounding(maskBounding, width, height);
                    const maskBoundingCenterX = maskBoundingX1 + (maskBoundingX2 - maskBoundingX1) / 2;
                    const maskBoundingCenterY = maskBoundingY1 + (maskBoundingY2 - maskBoundingY1) / 2;
                    // Calculate mask transformation
                    const maskTransform = mask.transform || fym_lib_1.ApplyTransform.default();
                    const maskTransformScaleX = maskTransform.scaleX;
                    const maskTransformScaleY = maskTransform.scaleIsZoom ? maskTransform.scaleX : maskTransform.scaleY;
                    const maskScaleX = (width / ClientSVGSetting_1.ClientSVGSetting.width) * maskTransformScaleX;
                    const maskScaleY = (height / ClientSVGSetting_1.ClientSVGSetting.height) * maskTransformScaleY;
                    const maskTransformTranslateX = maskBoundingCenterX - maskBoundingCenterX * maskTransformScaleX;
                    const maskTransformTranslateY = maskBoundingCenterY - maskBoundingCenterY * maskTransformScaleY;
                    // Apply transformation to mask
                    // TODO: rotate mask
                    p.addPath(p1, new DOMMatrix([
                        maskScaleX,
                        0,
                        0,
                        maskScaleY,
                        // (maskTransform.translateX * width) / 100 + maskTransformTranslateX,
                        // (maskTransform.translateY * height) / 100 + maskTransformTranslateY,
                        (maskTransform.translateX * settings.width) / 100 + maskTransformTranslateX,
                        (maskTransform.translateY * settings.height) / 100 + maskTransformTranslateY,
                    ]));
                    // Mask
                    context.clip(p);
                    // Debug mask
                    if (LOG) {
                        context.fillStyle = 'rgba(0, 0, 255, .3)';
                        context.fill(p);
                    }
                    // End debug
                    Renderer.drawImage(context, renderItemImage, imageBounding, renderItem.transform, settings);
                });
            }
            // context.closePath()
            context.restore();
            // Debug bounding
            if (LOG) {
                const [boundingX1, boundingY1, boundingX2, boundingY2, boundingWidth, boundingHeight] = imageBounding;
                const boundingCenterX = boundingX1 + (boundingX2 - boundingX1) / 2;
                const boundingCenterY = boundingY1 + (boundingY2 - boundingY1) / 2;
                context.fillStyle = 'rgba(255,0,0,.2)';
                context.fillRect(boundingX1, boundingY1, boundingWidth, boundingHeight);
                context.fillStyle = `rgba(${(1 - (i + 1) / len) * 255},${((i + 1) / len) * 255}, ${(1 - (i + 1) / len) * 255},1)`;
                context.fillRect(boundingCenterX - 4, boundingCenterY - 4, 8, 8);
            }
            // End Debug
        }
        let finalCanvas = canvas_1.createCanvas(settings.width, settings.height);
        let finalCanvasContext = finalCanvas.getContext('2d');
        const finalSize = [width * settings.scale, height * settings.scale];
        const finalTranslate = [width * settings.translate[0], height * settings.translate[1]];
        const offset = [(finalSize[0] - width) / 2, (finalSize[1] - height) / 2];
        finalCanvasContext.drawImage(canvas, -offset[0] + finalTranslate[0], -offset[1] + finalTranslate[1], finalSize[0], finalSize[1], 0, 0, settings.width, settings.height);
        if (settings.watermark && watermark) {
            finalCanvasContext.drawImage(watermark, 0, 0, settings.width, settings.height);
        }
        if (bNode) {
            return finalCanvas.toBuffer('image/jpeg', {
                quality: 1,
                progressive: true,
                chromaSubsampling: false,
            });
        }
        return new Promise(resolve => {
            const canvas = finalCanvas;
            canvas.toBlob(blob => {
                resolve(blob);
            }, 'image/jpeg', 1);
        });
    }
    static drawImage(context, image, imageFinalBounding, transform, settings) {
        const imageFinalBoundingCenterX = imageFinalBounding[0] + (imageFinalBounding[2] - imageFinalBounding[0]) / 2;
        const imageFinalBoundingCenterY = imageFinalBounding[1] + (imageFinalBounding[3] - imageFinalBounding[1]) / 2;
        const scaleX = transform.scaleX;
        const scaleY = transform.scaleIsZoom ? transform.scaleX : transform.scaleY;
        const translateXByScale = imageFinalBoundingCenterX / scaleX - imageFinalBoundingCenterX;
        const translateYByScale = imageFinalBoundingCenterY / scaleY - imageFinalBoundingCenterY;
        if (transform.rotateZ !== 0) {
            context.translate(imageFinalBoundingCenterX, imageFinalBoundingCenterY);
            context.rotate((transform.rotateZ * Math.PI) / 180);
            context.translate(-imageFinalBoundingCenterX, -imageFinalBoundingCenterY);
        }
        context.scale(scaleX, scaleY);
        context.translate((transform.translateX * settings.width) / 100, (transform.translateY * settings.height) / 100);
        context.globalAlpha = transform.opacity;
        context.drawImage(image, translateXByScale, translateYByScale);
    }
    /**
     * Used in updateThumb for element
     *
     * @static
     * @param {string} svgString
     * @param {ICropping} croppingMeta
     * @param {[number, number]} originalSize
     * @param {[number, number]} destSize
     * @returns {Promise<string>}
     */
    static async cropSVG(svgString, croppingMeta, finalSize) {
        const canvas = canvas_1.createCanvas(croppingMeta.size[0], croppingMeta.size[1], 'svg');
        const context = canvas.getContext('2d', {
            pixelFormat: bNode ? 'RGBA32' : undefined,
        });
        context.patternQuality = 'best';
        context.quality = 'best';
        context.imageSmoothingEnabled = true;
        context.imageSmoothingQuality = 'high';
        context.antialias = 'subpixel';
        const destCenter = [canvas.width / 2, canvas.height / 2];
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.save();
        context.translate(destCenter[0], destCenter[1]);
        context.scale(croppingMeta.scale, croppingMeta.scale);
        context.drawImage(await SVG_1.SVG.toImage(svgString, croppingMeta.size[0], croppingMeta.size[1]), -destCenter[0] - croppingMeta.translate[0] * destCenter[0], -destCenter[1] - croppingMeta.translate[1] * destCenter[1]);
        context.restore();
        return canvas.toBuffer('image/png', {
            compressionLevel: 0,
            resolution: 300,
            filters: canvas.PNG_FILTER_NONE,
        });
    }
    static resize(canvas, destSize, imagetype = 'image/png') {
        const destCanvas = canvas_1.createCanvas(destSize[0], destSize[1]);
        destCanvas.getContext('2d').drawImage(canvas, 0, 0, canvas.width, canvas.height, 0, 0, destSize[0], destSize[1]);
        return imagetype === 'image/jpeg' ? destCanvas.toDataURL('image/jpeg', 1) : destCanvas.toDataURL('image/png');
    }
    static calculateRelativeBounding(bounding, width, height) {
        const x1 = bounding[0] * width;
        const w = bounding[2] * width;
        const x2 = x1 + w;
        const y1 = bounding[1] * height;
        const h = bounding[3] * height;
        const y2 = y1 + h;
        return [x1, y1, x2, y2, w, h];
    }
}
exports.Renderer = Renderer;
